import type {
  GlobalState, TabArgs,
  TabState,
} from '../types';

import { getCurrentTabId } from '../../util/establishMultitabRole';
import { INITIAL_TAB_STATE } from '../initialState';

export function selectTabState<T extends GlobalState>(
  global: T, ...[tabId = getCurrentTabId()]: TabArgs<T>
): TabState {
  if (!global?.byTabId) {
    return INITIAL_TAB_STATE;
  }

  return global.byTabId[tabId] || INITIAL_TAB_STATE;
}
